import React, {Component, Fragment} from 'react';
import MediaSelectModal from '../Forms/MediaSelectModal';
import InputField from './InputField'
import {mediaUrl} from "../../helpers/Helpers";
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";
import BtnPrimary from "../UI/BtnPrimary";
import MediaItem from "../UI/MediaItem";
import {single} from "../../store/actions/media";
import {connect} from "react-redux";

class FileField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            file: {},
            fileDownloadLinkTitle: null
        };

        this.clear = this.clear.bind(this);
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            if (value.mediaId) {
                this.props.single(value.mediaId);
            }
            this.setState({
                file: value
            });
        }
    }

    setFile(file) {
        let fileData = {
            mediaId: file.id,
            mediaUrl: mediaUrl(file),
            fileDownloadLinkTitle: this.state.fileDownloadLinkTitle
        };

        this.props.input.onChange(fileData);
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    clear() {
        const {input} = this.props;

        input.onChange(null);

        this.setState({
            file: null,
            modal: false
        });
    }

    showMediaSelector() {
        this.setState({
            modal: true
        });
    }

    insertFile(name, listOfMediaFiles) {
        if (listOfMediaFiles.length === 1) {
            this.setFile(listOfMediaFiles[0]);
            this.setState({file: listOfMediaFiles[0]});
        }

        this.hideModal();
    }

    changeDownloadLinkTitle(event) {
        this.setState({fileDownloadLinkTitle: event.target.value});
        this.setFile(this.state.file);
    }

    onClose() {
        this.setState({modal: false});
    }

    render() {
        const {modal, file} = this.state;
        const {input, label, meta: {touched, error}, defaultFileType, loadedMediaItem} = this.props;
        let mediaItem = file ? file : (input.value ? input.value : null);

        if (mediaItem && loadedMediaItem && loadedMediaItem.data.id === mediaItem.mediaId) {
            mediaItem = {
                ...mediaItem,
                ...loadedMediaItem.data
            }
        }

        return (
            <Fragment>
                <div
                    className={classNamesPrefixed({
                        'FileField': true
                    })}
                >
                    {label &&
                    <label>{label}</label>
                    }
                    {input.value === '' ? (
                        <div
                            className={classNamesPrefixed({
                                'FileField-empty': true
                            })}
                        >
                            <p>
                                <i
                                    className={classNamesPrefixed({
                                        'grey-color': true
                                    })}
                                >Choose a file from the media library or upload a new one.</i>
                            </p>
                            <div
                                className={classNamesPrefixed({
                                    'form-actions': true
                                })}
                            >
                                <BtnPrimary onClick={(event) => this.showMediaSelector(event)}>Select file</BtnPrimary>
                            </div>
                        </div>
                    ) : (
                        <div
                            className={classNamesPrefixed({
                                'FileField-selected': true
                            })}
                        >
                            <div
                                className={classNamesPrefixed({
                                    'FileField-file': true
                                })}
                            >
                                {mediaItem &&
                                <MediaItem
                                    item={mediaItem}
                                    key={mediaItem.id}
                                    editEnabled={false}
                                    deleteEnabled={true}
                                    onDelete={this.clear}
                                    selectEnabled={false}
                                    maxSelectItems={0}
                                    clickableThumbnail={false}
                                />
                                }
                            </div>
                            <div
                                className={classNamesPrefixed({
                                    'FileField-info': true
                                })}
                            >
                                <InputField
                                    omitCollapsible={true}
                                    input={{
                                        onChange: (event) => this.changeDownloadLinkTitle(event),
                                        defaultValue: file.fileDownloadLinkTitle
                                    }}
                                    meta={{
                                        touched: false,
                                        error: false
                                    }}
                                    label="Download link title"
                                    placeholder="Ex. Download document here!"
                                />
                            </div>
                        </div>
                    )}
                </div>
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
                <MediaSelectModal
                    show={modal}
                    maxSelectItems={1}
                    onInsert={(name, itemsToInsert) => this.insertFile(name, itemsToInsert)}
                    filterMediaTypeEnabled={true}
                    defaultMediaType={defaultFileType}
                    onClose={() => this.onClose()}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loadedMediaItem: state.media.item
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        single: (id) => dispatch(single(id))
    };
};

FileField = connect(mapStateToProps, mapDispatchToProps)(FileField);

export default FileField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/FileField.js